import _ from 'lodash';
import { refApplicationStateService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefApplicationState() {
    return {
        refApplicationStateId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        isToBeRetired: false,
        applicationCount: 0,
        itServiceCount: 0
    };
}

export const refapplicationstates = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefApplicationState: getBlankRefApplicationState()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refApplicationStateService.getByAccount(accountId)
                    .then(
                        refApplicationStates => {
                            commit(GET_ALL_SUCCESS, refApplicationStates);
                            resolve(refApplicationStates);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refApplicationStateId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refApplicationStateService.getById(refApplicationStateId)
                    .then(
                        refApplicationState => {
                            commit(GET_BY_ID_SUCCESS, refApplicationState);
                            resolve(refApplicationState);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refApplicationState) {
            return refApplicationStateService.add(refApplicationState);
        },
        [UPDATE]({ dispatch, commit }, refApplicationState) {
            return refApplicationStateService.update(refApplicationState);
        },
        [DELETE]({ dispatch, commit }, refApplicationState) {
            return refApplicationStateService.deleteRefApplicationState(refApplicationState);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refApplicationStates) {
            state.status = { loaded: true };
            state.items = refApplicationStates;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refApplicationState) {
            state.status = { loaded: true };
            state.currentRefApplicationState = refApplicationState;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefApplicationState = getBlankRefApplicationState();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefApplicationState = getBlankRefApplicationState();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefApplicationState, {
                [field]: value
            });
        },
    }
}
